export enum AtelierUpdateCheckedIdentifier {
  ATELIER_INFO,
  CONFIGURATION,
  TITLE,
  PHONE_NUMBER,
  TEXT,
  IMMOSCOOP,
  SPOTTO,
  SECOND_BOARD,
  ARROWS,
  OTHER_ORDER,
  REVIEWED,
  EXTRA_BOARD,
  ATELIER_EXTRA_INFO,
  TASK_DESCRIPTION_READ,
  TASK_PREPARED,
  TASK_REVIEWED,
  STOCK_AT_BRANCH,
  FRAME,
  FRAME_COLOR,
}
